import CompLayout from "@/pcomponents/comp/layout/layout";
import TradeFixListArea from "@/pages/comp/supply/trade_fix/common/list";

function TradeFixListPage(props: any) {
  let myProps = {
    ...props
  };

  return (
    <CompLayout isConTitle={false}>
      <TradeFixListArea></TradeFixListArea>
    </CompLayout>
  );
};
export default TradeFixListPage;